import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './CheckBox.less';
import Icon, { ICON_TYPE } from '../Icon/Icon';

export const CHECKBOX_LABEL_STYLE = {
    NORMAL: '',
    SUPPORTING: 'vx_text-legal'
};

export default class CheckBox extends Component {
    static propTypes = {
        alignLabelTop: PropTypes.bool, // Align label to the top of the checkbox (for multi-line labels)
        allowErrorPopout: PropTypes.bool,
        description: PropTypes.node,
        disabled: PropTypes.bool,
        id: PropTypes.string.isRequired,
        label: PropTypes.node.isRequired,
        labelStyle: PropTypes.oneOf(Object.values(CHECKBOX_LABEL_STYLE)),
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onClick: PropTypes.func,
        onFocus: PropTypes.func,
        readOnly: PropTypes.bool,
        required: PropTypes.bool,

        // Provided by Field HOC
        input: PropTypes.object.isRequired,
        meta: PropTypes.object.isRequired
    };

    static defaultProps = {
        alignLabelTop: false,
        allowErrorPopout: false,
        disabled: false,
        labelStyle: CHECKBOX_LABEL_STYLE.SUPPORTING,
        readOnly: false,
        required: false
    };

    // workaround for meta.touched always false before submit
    // It's a bug https://github.com/erikras/redux-form/issues/3330
    onBlur = (e) => {
        this.touched = true;
        this.props.onBlur && this.props.onBlur(e);
    };

    render() {
        const {
            alignLabelTop,
            allowErrorPopout,
            id,
            input,
            description,
            disabled,
            label,
            labelStyle,
            meta: {
                active,
                touched,
                error
            },
            onClick,
            onFocus,
            readOnly,
            required
        } = this.props;
        const inputName = input.name || id;
        const hasError = !!((active || touched || this.touched) && error);
        const errorClass = hasError ? error.className : '';
        const wrapperClasses = [
            'CheckBox',
            'vx_checkbox',
            errorClass
        ];

        return (
            <div className={wrapperClasses.join(' ')}>
                <input
                    {...input}
                    type="checkbox"
                    name={inputName}
                    id={id}
                    checked={input.value}
                    disabled={disabled}
                    onClick={onClick}
                    onFocus={onFocus}
                    onBlur={this.onBlur}
                    readOnly={readOnly}
                    required={required}
                    data-errormsg={error && (error.msg || '')}
                    data-errorshowmsg={hasError && allowErrorPopout}
                    data-haserror={hasError}
                />
                <label
                    htmlFor={id}
                    className={`Checkbox-label-wrapper label-for-${id}`}
                    data-automation-id={`checkbox-${id}`}
                >
                    <div className={`CheckBox-text-wrapper ${alignLabelTop ? 'label-top' : ''}`}>
                        <div className={`CheckBox-text CheckBox-text-for-${id} ${labelStyle}`}>{label}</div>
                        {description && <div className="CheckBox-desc vx_text-legal">{description}</div>}
                        {hasError && (
                            <div className="CheckBox-errorMsg vx_text-body-sm">
                                <div className="CheckBox-errorMsg-left">
                                    <Icon type={ICON_TYPE.CRITICAL} className="CheckBox-errorIcon" />
                                </div>
                                <div className="CheckBox-errorMsg-right">
                                    {error.msg}
                                </div>
                            </div>
                        )}
                    </div>
                </label>
            </div>
        );
    }
}
